const ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;

const ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;

const ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;

const AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;

const AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;

const JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
  }
`;

const JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${JiraSingleIssueLineTextFieldFragment}
`;

export const operationName = 'QuickFindActivitiesQuery';

// TODO: we could use partials instead of fragments, similarly to how it's done in search-page
export const quickFindRecentActivitiesQuery: '\n  query QuickFindActivitiesQuery(\n    $filteredProducts: [String!]\n    $filteredObjectTypes: [String!]\n    $itemsLimit: Int!\n    $filteredRootContainerIds: [ID!]\n  ) {\n    activity {\n      myActivity {\n        all(\n          filter: {\n            arguments: {\n              products: $filteredProducts\n              objectTypes: $filteredObjectTypes\n            }\n            rootContainerIds: $filteredRootContainerIds\n          }\n          first: $itemsLimit\n        ) {\n          __typename\n          edges {\n            __typename\n            node {\n              __typename\n              object {\n                __typename\n                id\n                type\n                product\n                data {\n                  __typename\n                  ...ConfluencePageFragment\n                  ...ConfluenceBlogPostFragment\n                  ...ConfluenceWhiteboardFragment\n                  ...AtlasProjectFragment\n                  ...AtlasGoalFragment\n                  ...JiraIssueFragment\n                }\n              }\n              event {\n                __typename\n                eventType\n                timestamp\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  \n  fragment ConfluencePageFragment on ConfluencePage {\n    __typename\n    title\n    pageStatus: status\n    subtype\n    ancestors {\n      __typename\n      id\n      title\n    }\n    links {\n      __typename\n      base\n      webUi\n    }\n    space {\n      id\n      name\n    }\n  }\n\n  \n  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {\n    __typename\n    title\n    blogStatus: status\n    links {\n      __typename\n      base\n      webUi\n    }\n    space {\n      id\n      name\n    }\n  }\n\n  \n  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {\n    __typename\n    title\n    links {\n      base\n      webUi\n    }\n    space {\n      id\n      name\n    }\n  }\n\n  \n  fragment AtlasProjectFragment on TownsquareProject {\n    __typename\n    key\n    name\n    url\n    iconData\n  }\n\n  \n  fragment AtlasGoalFragment on TownsquareGoal {\n    __typename\n    key\n    name\n    url\n    iconData\n  }\n\n  \n  fragment JiraIssueFragment on JiraIssue {\n    __typename\n    key\n    webUrl\n    fieldsById(ids: ["summary"]) {\n      edges {\n        node {\n          __typename\n          ...JiraSingleIssueLineTextFieldFragment\n        }\n      }\n    }\n  }\n  \n  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {\n    text\n  }\n\n\n' = `
  query ${operationName}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
        ) {
          __typename
          edges {
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${ConfluencePageFragment}
  ${ConfluenceBlogPostFragment}
  ${ConfluenceWhiteboardFragment}
  ${AtlasProjectFragment}
  ${AtlasGoalFragment}
  ${JiraIssueFragment}
`;
